import { render, staticRenderFns } from "./MiniChip.vue?vue&type=template&id=8f97d72e&scoped=true"
import script from "./MiniChip.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MiniChip.vue?vue&type=style&index=0&id=8f97d72e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f97d72e",
  null
  
)

export default component.exports